import { Column } from "@/constants/pipeline";
import * as React from "react";
import { Cell } from "./Cell";

type RowContentProps = {
  columns: Column[];
  children: React.ReactNode;
  sortBy?: string;
  highlightColor?: string;
};

export const RowContent: React.FC<RowContentProps> = ({ columns, children, sortBy, highlightColor }) => {
  const flatChildren = React.Children.toArray(children);

  return (
    <>
      {flatChildren.map((child, index) => (
        <Cell key={`cell-${index}`} columns={columns} index={index} sortBy={sortBy} highlightColor={highlightColor}>
          {child}
        </Cell>
      ))}
    </>
  );
};
